import React from 'react';
import {
  FormTab,
  TextField,
  ReferenceField,
  ReferenceManyField,
  Datagrid,
  DeleteButton,
} from 'react-admin';
import CreateRelatedButton from '../components/CreateRelatedButton';
import { isProductiveRule } from './regla-utils';

const ReglaTiposTransaccionTab = ({ ...props }) => {
  const _isProductiveRule = isProductiveRule(props);
  return (
    <FormTab label="resources.regla.tabs.tipo-transaccion" path="tipo-transaccion" {...props}>
      {!_isProductiveRule && (
        <CreateRelatedButton
          reference="regla-tipo-transaccion"
          refFieldName="idRegla"
          label="resources.regla.buttons.asociarTipoTransaccion"
        />
      )}
      <ReferenceManyField
        addLabel={false}
        reference="regla-tipo-transaccion"
        target="idRegla"
        sort={{ field: "idTipoTransaccion", order: "DESC" }}
        filter={{ deleted: false }}
      >
        <Datagrid>
          <TextField
            source="idTipoTransaccion"
            label="resources.tipos-transaccion.fields.id"
          />
          <ReferenceField
            label="resources.tipos-transaccion.fields.descripcion"
            source="idTipoTransaccion"
            reference="tipos-transaccion"
            link={false}
          >
            <TextField source="descripcion" />
          </ReferenceField>
          {!_isProductiveRule && (
            <DeleteButton activar mutationMode="optimistic" redirect={false} />
          )}
        </Datagrid>
      </ReferenceManyField>
    </FormTab>
  );
};

export default ReglaTiposTransaccionTab;
